import { render, staticRenderFns } from "./fundProject.vue?vue&type=template&id=8c5a8b54"
import script from "./fundProject.vue?vue&type=script&lang=js"
export * from "./fundProject.vue?vue&type=script&lang=js"
import style0 from "./fundProject.vue?vue&type=style&index=0&id=8c5a8b54&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports